<template>
  <div>
    <div class="page-title mb-30">Pods</div>
    <div class="page-content max-w-1000" v-loading="loading">
      <div class="section-title mb-20">
        <span class="right-float">
          <img src="@/assets/filter.svg" />
          <el-input
            v-model="filter"
            size="mini"
            class="search-input filter-input"
            placeholder="filter by pod mac"
          ></el-input>
        </span>
      </div>
      <el-table border size="small" :data="displayData">
        <el-table-column
          label="Pod"
          prop="PodMac"
          fixed="left"
        ></el-table-column>
        <el-table-column label="Room" prop="RoomNumber"></el-table-column>
        <el-table-column label="Bed" prop="BedNumber"></el-table-column>
        <el-table-column
          label="Organisation"
          prop="Organisation"
        ></el-table-column>
        <el-table-column label="Action" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              class="delete-btn mini-btn min-w-80 ml-10"
              @click="unlinkPod(scope.row)"
              >Unlink</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ReportApiService.js'
export default {
  data() {
    return {
      loading: false,
      data: [],
      displayData: [],
      filter: '',
      timer: ''
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.filterPods, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetPodList()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data
            this.displayData = this.data
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    filterPods() {
      this.displayData = this.data.filter(item => {
        return item.PodMac.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      })
    },
    unlinkPod(item) {
      this.$confirm(
        'Please keep in mind that unlink pods is permanent.',
        `You're about to unlink ${item.PodMac}`,
        {
          confirmButtonText: 'UNLINK',
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleUnlink(item.id)
        })
        .catch(() => {})
    },
    handleUnlink(id) {
      ApiService.UnlinkPod(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Unlink Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Unlink Failed'
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
